module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_decoration_image_01-071cc96fd98cfcd2b6bbe8c785421900.png";